import { useEffect, useRef, useState } from 'react';

export function useScrollShadow<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null);
  const [showEndShadow, setShowEndShadow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      const remaining = el.scrollWidth - el.clientWidth - el.scrollLeft;
      setShowEndShadow(remaining > 1);
    };

    check();

    el.addEventListener('scroll', check, { passive: true });
    const resizeObserver = new ResizeObserver(check);
    resizeObserver.observe(el);

    return () => {
      el.removeEventListener('scroll', check);
      resizeObserver.disconnect();
    };
  }, []);

  return { ref, showEndShadow };
}
